enum Role {
    Presenter= 'PRESENTER',
    Participant= 'PARTICIPANT'
}

enum SortOrder {
    Asc= 'asc',
    Desc= 'desc'
}
interface IEventRequestParams {
    eventId: number;
    accountId: number;
    timeZone?: string;
}

interface IUploadRequestParams {
    accountId: number;
    eventId?: number;
}

interface IContactUploadRequestParams {
    contactId: number;
}

interface IWithExternalIdEventRequestParams extends IEventRequestParams {
    externalId: string;
}

interface IFileParams extends IEventRequestParams {
    file: File;
    separator?: string;
}
interface IPaginationParams {
    query?: string;
    page?: number;
    size?: number;
}

export interface IInfinityScrollPaginationParams {
    ['page-size']?: number;
    sort?: string;
    direction?: SortDirection;
    ['next-page-token']?: string;
}

export enum SortDirection {
    Ascending = 'Asc',
    Descending = 'Desc'
}

interface IPaginatedContentResponse<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    size: number;
    // eslint-disable-next-line id-denylist
    number: number;
    first: boolean;
    last: boolean;
    numberOfElements: number;
    empty: boolean;
}

interface ISortRequestParams<TSortKeys> {
    sortField: TSortKeys | TSortKeys[];
    sortOrder: SortOrder;
}

interface ISortFieldsRequestParams<TSortKeys> {
    sortFields: ISortField<TSortKeys>[];
}

interface ISortField<TSortKey> {
    field: TSortKey;
    order: SortOrder;
}

interface IAddedUpdatedDataCount {
    addedOrganizationsCount: number;
    updatedOrganizationsCount: number;
    addedAttendeesCount: number;
    updatedAttendeesCount: number;
}

interface IImageWithObjectKey {
    title: string;
    objectKey?: string;
}

interface IImageWithUrl {
    title: string;
    assetUrl?: string;
    assetMetadataId?: number;
    objectKey?: string;
}

interface IImageUploadUrl {
    title: string;
    assetUrl?: string;
    objectKey?: string;
}

interface IImage extends IImageWithObjectKey, IImageWithUrl {}

interface IAssetUrlDTO {
    assetUrl: string;
    objectKey: string;
}

interface IAudioWithUrl {
    title: string;
    audioUrl?: string;
}

interface S3ObjectMetadata {
    objectKey: string;
    title: string;
}

/**
 * return a copy of passed in object, replacing 'sortField' and 'sortOrder' fields with 'sort' field, understandable by API
 * @param params
 */
const replaceSortRequestParamsWithSortString = (params: ISortRequestParams<{}> | ISortFieldsRequestParams<{}>) => {
    let processedParams;
    let sort = null;

    const buildSortQueryParamValue = (field, order) => {
        return field && order ? `${String(field)},${String(order)}` : '';
    };

    if ('sortFields' in params) {
        const { sortFields, ...otherParams } = params;
        sort = [];

        sortFields.forEach(sortField => {
            const paramValue = buildSortQueryParamValue(sortField.field, sortField.order);
            sort.push(paramValue);
        });

        processedParams = { ...otherParams, sort: sort };
    } else {
        const { sortField, sortOrder, ...otherParams } = params;

        if (sortField instanceof Array) {
            sort = [];
            for (const field of sortField) {
                const paramValue = buildSortQueryParamValue(field, sortOrder);
                sort.push(paramValue);
            }
        } else {
            sort = buildSortQueryParamValue(sortField, sortOrder);
        }

        processedParams = { ...otherParams, sort: sort };
    }

    return processedParams;
};

export {
    Role,
    SortOrder,
    IEventRequestParams,
    IUploadRequestParams,
    IContactUploadRequestParams,
    ISortRequestParams,
    IWithExternalIdEventRequestParams,
    replaceSortRequestParamsWithSortString,
    IPaginationParams ,
    IAddedUpdatedDataCount,
    IFileParams,
    ISortFieldsRequestParams,
    IImage,
    IImageWithObjectKey,
    IImageWithUrl,
    IAssetUrlDTO,
    IImageUploadUrl,
    S3ObjectMetadata,
    IAudioWithUrl,
    IPaginatedContentResponse
};
